module.exports = __webpack_public_path__ + "img/sec2-2.8d7c5d8c.png";